module.exports = __webpack_public_path__ + "img/unique-bg.51def80a.svg";